<div class="widget form-group">
  <label [attr.for]="id" class="horizontal control-label">
    {{ schema.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>

  <div class="popq-field-table">
    <sp-form-element [formProperty]="formProperty.getProperty('aa')"></sp-form-element>
    <sp-form-element [formProperty]="formProperty.getProperty('ba')"></sp-form-element>
    <sp-form-element [formProperty]="formProperty.getProperty('c')"></sp-form-element>

    <sp-form-element [formProperty]="formProperty.getProperty('gh')"></sp-form-element>
    <sp-form-element [formProperty]="formProperty.getProperty('pb')"></sp-form-element>
    <sp-form-element [formProperty]="formProperty.getProperty('tvl')"></sp-form-element>

    <sp-form-element [formProperty]="formProperty.getProperty('ap')"></sp-form-element>
    <sp-form-element [formProperty]="formProperty.getProperty('bp')"></sp-form-element>
    <sp-form-element [formProperty]="formProperty.getProperty('d')"></sp-form-element>
  </div>
  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/popq.widget.html